import { Component, OnInit, ViewChild, ViewContainerRef, ElementRef, TemplateRef, Output, EventEmitter, Input, AfterViewInit} from '@angular/core';
import { orderDetails } from './data';
import { EditService, ToolbarService, PageService, GridComponent, FilterService, PdfExportService, SelectionService, SortService, RowDataBoundEventArgs, modelChanged, IFilter, TextWrapSettingsModel, GroupSettingsModel, columnSelectionComplete } from '@syncfusion/ej2-angular-grids';
import { DataManager, Query, Predicate, ODataV4Adaptor, ReturnOption, DataUtil } from '@syncfusion/ej2-data';
import { Browser, getComponent, isNullOrUndefined  } from '@syncfusion/ej2-base';
import { DropDownButtonModule, BeforeOpenCloseMenuEventArgs } from '@syncfusion/ej2-angular-splitbuttons';
import { QueryBuilderComponent } from '@syncfusion/ej2-angular-querybuilder';
import { Popup } from '@syncfusion/ej2-popups';

import { RuleModel } from '@syncfusion/ej2-querybuilder';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { DemoService } from './../../../demo.service';
import { FileUploaderService } from './../../../services/file-uploader-service';
import { MysqlService } from './../../../services/mysql.service';
import { HotToastService } from '@ngneat/hot-toast';

import { BsModalService } from 'ngx-bootstrap';
import { SearchContact } from './../../../shared/models/searchContact.model';
import { DatePipe } from '@angular/common';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';

import { SubjectService } from './../../../api/subjectService';
import { SubjectAttendence } from './../../../api/subjectAttenence';
import { SearchAgentMetrics } from './../../../shared/models/searchAgentMetrics.model';
import { Brand } from './../../../shared/models/brand.model';


import { TabsetComponent } from 'ngx-bootstrap/tabs';

import * as c3 from 'c3';
import * as d3 from 'd3';
import { color } from 'd3-color';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-agent-performance-metrics',
  templateUrl: './agent-performance-metrics.component.html',
  styleUrls: ['./agent-performance-metrics.component.css'],
  providers: [ToolbarService, EditService, PageService, ToolbarService,
     PdfExportService, PageService, FilterService, SortService, SelectionService]
})
export class AgentPerformanceMetricsComponent implements OnInit, AfterViewInit {
  // public values: string[] = ['Mr.', 'Mrs.'];
  // public data: Object[];
  // public editSettings: Object;
  // public toolbar: any;
  // public orderidrules: Object;
  // public customeridrules: Object;
  // public freightrules: Object;
  // public pageSettings: Object;
  // public editparams: Object;
  // @ViewChild('template')
  // public toolbarTemplate: any;
  // @ViewChild('template2')
  // public DropDownButtonTemplate: any;
  // public ngOnInit(): void {
  //     this.data = orderDetails;
  //     this.editSettings = { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Dialog' };
  //     this.toolbar = ['Add', 'Edit', 'Delete','Search' ,  {template: this.DropDownButtonTemplate}];
  //     this.orderidrules = { required: true, number: true };
  //     this.customeridrules = { required: true };
  //     this.freightrules =  { required: true };
  //     this.editparams = { params: { popupHeight: '300px' }};
  //     this.pageSettings = { pageCount: 5};
  // }
  @ViewChild('querybuilder') qryBldrObj: QueryBuilderComponent;
  @ViewChild('grid') grid: GridComponent;
  isPopup:boolean = true;

  @ViewChild('chart') chart: c3.ChartAPI;
  @ViewChild('company_report_graph') company_report_graph;
    // TABS sets the selected
  @ViewChild('staticTabs') staticTabs: TabsetComponent;

  @ViewChild('agent_metrics_chart_full') agent_metrics_chart_full: c3.ChartAPI;
  @ViewChild('div1') div1: c3.ChartAPI;

  // createdControl(): void {
  //   if (Browser.isDevice) {
  //     this.qryBldrObj.summaryView = true;
  //   }
  // }

  //  importRules: RuleModel = {
  //     'condition': 'and',
  //     'rules': [{
  //             'label': 'Order ID',
  //             'field': 'OrderID',
  //             'type': 'number',
  //             'operator': 'equal',
  //             'value': 10250
  //         },
  //         {
  //             'label': 'Customer Name',
  //             'field': 'CustomerName',
  //             'type': 'string',
  //             'operator': 'equal',
  //             'value': "Antonio Moreno"
  //         }]
  //     };



  public groupOptions: GroupSettingsModel;
  public filter : IFilter;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  valueDatePickerDate: any;
  search_model: SearchAgentMetrics;
  toolbarOptions: string[];
  initialPage: { pageSize: number; };
  filterOptions: { type: string; };
  formatOptions: { type: string; format: string; };
  public wrapSettings: TextWrapSettingsModel; // this allows the content to wrap only Header|Content|Both

  brand_types: Object;
  users: Object;
  usersPrimary: Object;
  contact_search: Object;
  contact_search_results: any;
  job_metrix_join_results: any[];
  brand_user_join_results: any[];
  brand_search: Object;
  brand_search_results: any;
  brand_user_join_results_agent: any[];
  brand_search_results_agent: any;
  user_levels: Object;
  user_search: Object;
  user_search_results: any;
  search_results: any;
  dateFormat: string;

  pageOptions: { pageSize: number; };
  join_results: any[];
  agent_services: Object;
  agent_services_results: any;
  agent_jobs: any;
  agent_jobs_count: any;
  combo_model: Brand;
  brands_agent: any;

  // public job_fields: Object = { text: 'subject_id', value: 'subject_id' };
  public job_fields: Object = { text: 'subject_number', value: 'subject_number' };
  jobs: Object;
  subject_service_metrix_search: any;
  subject_service_metrix_search_results: any;
  modalRef: any;
  // company_report_graph: any;
  metric_1_words: string;
  metric_1_who_service: any;
  metric_1_subject_service_id: any;
  metric_1_date_1: any;
  metric_1_date_2: Date;
  metric_1: number;
  metric_1_hours: number;
  metric_1_text: string;
  metric_1_title: string;
  metric_1_subject_id: any;
  metric_1_subject_number: any;
  metric_1_data: any[];
  metric_2_data: any[];
  metric_2_data_join: any[];
  metric_2_date_1: any;
  metric_2_date_2: Date;
  metric_2: number;
  metric_3_data: any[];
  metric_3_date_1: Date;
  metric_3_date_2: Date;
  metric_3: number;
  metric_3_data_join: any[];
  metric_1_data_join: any[];
  metric_4_data: any;
  metric_4_date_1: Date;
  metric_4_date_2: Date;
  metric_4: number;
  metric_4_data_join: any[];
  metric_5_data: any;
  metric_5_date_1: Date;
  metric_5_date_2: Date;
  metric_5: number;
  metric_5_data_join: any[];
  metric_6_data: any;
  metric_6_date_1: Date;
  metric_6_date_2: Date;
  metric_6: number;
  metric_6_data_join: any[];
  config: any;
  typeOptions: string[];
  subject_service_metrix_search_full: any;
  subject_service_metrix_search_full_results: any;
  metric_1_result: string;
  metric_2_result: string;
  metric_3_result: string;
  metric_4_result: string;
  metric_5_result: string;
  metric_6_result: string;
  metric_1_count: any[];
  total_metic_1_count: number;
  metric_1_adverage_time_taken: number;
  metric_1_adverage_time_taken_words: string;
  metric_2_count: any[];
  metric_3_count: any[];
  metric_4_count: any[];
  metric_5_count: any[];
  metric_6_count: any[];
  total_metic_2_count: number;
  metric_2_adverage_time_taken: number;
  metric_2_adverage_time_taken_words: string;
  total_metic_3_count: number;
  metric_3_adverage_time_taken: number;
  metric_3_adverage_time_taken_words: string;
  total_metic_4_count: number;
  metric_4_adverage_time_taken: number;
  metric_4_adverage_time_taken_words: string;
  total_metic_5_count: number;
  metric_5_adverage_time_taken: number;
  metric_5_adverage_time_taken_words: string;
  total_metic_6_count: number;
  metric_6_adverage_time_taken: number;
  metric_6_adverage_time_taken_words: string;
  metric_2_string: string;
  arrayOfLinks: any[];
  brands_client: any;

  creating_search_data: number;

  // public fields: Object = { text: 'Game', value: 'Id' };
public brand_fields: Object = { text: 'NameAndAddress', value: 'brand_id' }; // using the name field not id!
  count_of_items: number;

  constructor(
    private http: HttpClient, private router: Router, route: ActivatedRoute,private _demoService: DemoService,
    public datepipe: DatePipe,
    public toastr: HotToastService,
    private _mysqlService: MysqlService, 
    public gfunc: GlobalFunctionsService,
    private modalService: BsModalService,
  ) { 

    this.combo_model = new Brand(); // loads the Trace model into the model vars for the form.
       // Set and Access login Session Variables
       this.gfunc.setLoginSessionVars(); // set in a global function file
       this.sessionUserId = this.gfunc.currentUserVAR.user_id;
       this.sessionUsername = this.gfunc.currentUserVAR.username;
       this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
      
            // need to add this as routes does not work globally
            this.all_router_details = this.router.url;
            this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
      
         //   this.toastr.setRootViewContainerRef(vcr);
      // Date picker date format
       //  this.valueDatePickerDate = new Date(this.today);
  
       this.creating_search_data = 0;

  }

  


// need to palce here for charts and anything JS
  ngAfterViewInit() {
    // this.chart = c3.generate({
    //   bindto: '#chart',
    //       data: {
    //           columns: [
    //               ['data1', 30, 200, 100, 400, 150, 250],
    //               ['data2', 50, 20, 10, 40, 15, 25]
    //           ]
    //       }
    //   });

  //   this.chart = c3.generate({
  //     bindto: '#agent_metrics_chart_full',
  //     data: {
  //         x: 'date',
  // //        xFormat: '%Y%m%d', // 'xFormat' can be used as custom format of 'x'
  //         rows: [
  //             ['date', 'data1', 'data2', 'data3'],
  //             [1398154158000, 10, 70, 20],
  //             [1398154159000, 10, 70, 20],
  //             [1398154160000, 10, 70, 20],
  //             [1398154161000, 10, 70, 20],
  //         ]
  //     },
  //     axis: {
  //         x: {
  //             type: 'timeseries',
  //             tick: {
  //                 format: '%M:%S'
  //             }
  //         }
  //     }
  // });



// INITIAL CLICK HANDLER
let clickhandler = function(event) {
  console.log("11111111111");
  console.log(event.d);
  console.log(event);
  // console.log('Subject_service_id: ', this.arrayOfLinks[d.x].subject_service_id);
  // console.log('Subject_number: ', this.arrayOfLinks[d.x].subject.number);
// console.log(arrayOfLinks[d.x]);
}

let div1 = this.div1;

// :: this was correct format for the function in the c3.js graph
const arrayOfLinks = [
  '121', '142', '163', '124'
  ];

let json1 = [{
date: '2014-01-01',
upload: 200,
download: 200,
total: 400
}, {
date: '2014-01-02',
upload: 100,
download: 300,
total: 400
}, {
date: '2014-02-01',
upload: 300,
download: 200,
total: 500
}, {
date: '2014-02-02',
upload: 400,
download: 100,
total: 500
}];

let json2 = [{
date: '2014-01-01',
upload: 200,
download: 500,
total: 700
}, {
date: '2014-01-02',
upload: 500,
download: 450,
total: 950
}, {
date: '2014-02-01',
upload: 200,
download: 800,
total: 1000
}, {
date: '2014-02-02',
upload: 300,
download: 500,
total: 800
}];

// GENERATE CHART FROM JSON1
div1 = c3.generate({
bindto: '#div1',
data: {
json: json1,
onclick: function(event) { clickhandler(event); },
keys: {
    x: 'date',
    value: ['upload', 'download']
}
},
axis: {
x: {
    type: 'timeseries',
    tick: {
        // format: function (x) {
        //     if (x.getDate() === 1) {
        //         return x.toLocaleDateString();
        //     }
        // },
        format: '%Y-%m-%d',
    }
}
}
});

// MAKE CHANGES TO THE LOADED CHART // 3 seconds
setTimeout(function () {
// CHANGE THE CLICK EVENT HANDLER
clickhandler = function(event) {
console.log('Reset Valuues:');
console.log('Links Array: ', arrayOfLinks[event.index]);
console.log('Event: ', event);
console.log('Event Value: ', event.value);
};
// UNLOAD EXISTING DATA AND LOAD NEW DATA FROM JSON2
div1.load({
  json: json2,
  keys: {
      x: 'date',
      value: ['upload', 'download']
  },
  // unload: this.div1.columns
});

// this.div1.load({
//         json: json2,
//         keys: {
//             x: 'date',
//             value: ['upload', 'download']
//         },
//         unload: this.div1.columns
// });
}, 3000);




  
// end company report graph data

  }



  ngOnInit() {

   
    // this.search_model = new SubjectService();   
    // this.search_model = new SubjectAttendence();    
    this.search_model = new SearchAgentMetrics();
    this.getFormUserLevels();
    this.getBrandBrandTypes();
    this.getBrandsComboBoxAgents(this.combo_model);
    this.getJobsTableData();


    this.combo_model = new Brand(); // loads the Trace model into the model vars for the form.
    this.getBrandsComboBoxClients(this.combo_model);

    // this.mapJobTableLive(); // load the table data
    // this.mapJobTableLiveClients();
    // this.mapJobTableLiveAgents();
    // , 'PdfExport'
    this.toolbarOptions = ['ExcelExport', 'Search'];
    this.initialPage = { pageSize:5 };
    this.filterOptions = {
      type: 'Menu'
   };
  // this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
   this.formatOptions= {type:'date', format:'dd/MM/yyyy' };
   this.dateFormat = 'dd/MM/yyyy hh:mm a';
   this.filter = { params: { format: this.dateFormat } };
  this.pageOptions = { pageSize: 100 }; 
  this.wrapSettings = { wrapMode: 'Content' }; // this allows the content to wrap only Header|Content|Both
  }







 



  toolbarClick(args: ClickEventArgs): void {
    if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
        this.grid.excelExport();
    }
  }
  rowDataBound(args: RowDataBoundEventArgs) {
    const job_status = 'job_status';
    if (args.data[job_status] === 'CLOSED') {
        args.row.className = 'strikethrough';
    }
  }
  
  refreshGrid(){ // refresh the databutton
    this.mapJobTableLive();
    this.grid.refresh();
  }mapJobTableLive() {
    throw new Error('Method not implemented.');
  }
;
  
  
  
  
  getBrandBrandTypes(){
    this._demoService.getBrandBrandTypes().subscribe(
      data => { this.brand_types = data;
       let res = data[0];
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  getJobsTableData(){
    this._demoService.getJobsTableData().subscribe(
      data => {this.jobs = data;
      let res = data[0];
      }
    )
  }
  
  getUsers() {
    this._demoService.getUsers().subscribe(
      data => { this.users = data;
        this.usersPrimary = data;
       let res = data[0];
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }
  
  
  brandView(brand_id) {
    this.router.navigate(['/admin/brands/company/view/' + brand_id + '']);
  }
  
  brandEdit(brand_id) {
    this.router.navigate(['/admin/brands/company/edit/' + brand_id + '']);
  }
  
  
  userView(user_id) {
    this.router.navigate(['/admin/brands/users/view/' + user_id + '']);
  }
  
  userEdit(user_id) {
    this.router.navigate(['/admin/brands/users/edit/' + user_id + '']);
  }
  
  
  
  
  // :: Reporting
  getReportContactsSearch(search_model) {
  
    search_model.brand_type_id = null;
    search_model.assigned_agent = null;
    this._demoService.getReportContactsSearch(search_model).subscribe(
      data => { this.contact_search = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.contact_search_results = DataUtil.parse.parseJson(data); 
     //   this.subjects_results = DataUtil.parse.parseJson(data); 
       // console.log("Done loadng USER");
      //  console.log(data);
  
     //  this.items = new DataManager(data as JSON[]).executeLocal(new Query().take(1000));
       this.grid.refresh();
     
       // :: This section allow to hard code predicate filters before loading data in to DataManager
  
        // let predicate: Predicate = new Predicate('subject_name', 'equal', 'Mr Josh Mosh');
        // predicate = predicate.or('subject_id', 'equal', 303);
        // this.items =  new DataManager(this.subjects_urgent).executeLocal(new Query().where(predicate).take(8));
  
      },
      error => {
      console.error('Error Loading !' + error.error);
      console.log(error);
      //return Observable.throw(error);
      }
    ); }
  
  
  
    
  // :: Reporting
  getReportBrandsClientSearch(search_model) {
  this.brand_user_join_results = [];
  search_model.brand_type_id = 2;
  search_model.access_level = 9;
  
  
    // search_model.brand_report_id = null;
    // search_model.assigned_agent = null;
    this._demoService.getReportBrandsSearch(search_model).subscribe(
      data => { this.brand_search = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.brand_search_results = DataUtil.parse.parseJson(data); 
  // get the users as well and join the records together
  this.getReportUsersSearch(search_model);
  
  // now how to join two arrays of objects.
  // maybe pass results in to a new model.
  
  // Count items of brand search to loop through
  let  count_of_brand_items = Object.keys(this.brand_search).length;
  // now loop and push to join model
  for(let i=0;i < count_of_brand_items; i++) {
    let res = this.brand_search[i];
  
      // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
      this.brand_user_join_results.push({
        email_address: res.email,
        first_name: res.name,
        surname: res.surname,
        company_name: res.name,
        created: res.created,
              });
  
  } // end brands loop.
  
  
  
  
  
  
  this.brand_user_join_results = this.brand_user_join_results;
  
       this.grid.refresh();
      },
      error => {
      console.error('Error Loading !' + error.error);
      console.log(error);
      // return Observable.throw(error);
      }
  
  
  
      
    ); }
  
  
  
    
  
    getReportBrandsAgentSearch(search_model) {
      this.brand_user_join_results = [];
      search_model.brand_type_id = 3;
      search_model.access_level = 5;
      this._demoService.getReportBrandsSearch(search_model).subscribe(
        data => { this.brand_search = data;
          // pass so that the dates are correct in Sync
          // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
          this.brand_search_results = DataUtil.parse.parseJson(data); 
    // get the users as well and join the records together
    this.getReportUsersSearch(search_model);
    
    // now how to join two arrays of objects.
    // maybe pass results in to a new model.
    
    // Count items of brand search to loop through
    let  count_of_brand_items = Object.keys(this.brand_search).length;
    // now loop and push to join model
    for(let i=0;i < count_of_brand_items; i++) {
      let res = this.brand_search_results[i];
    
        // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
        this.brand_user_join_results.push({
          email_address: res.email,
          first_name: res.name,
          surname: res.surname,
          company_name: res.name,
          created: res.created,
                });
    
    } // end brands loop.
    
    this.brand_user_join_results = this.brand_user_join_results;
    
         this.grid.refresh();
      
          },
          error => {
          console.error('Error Loading !' + error.error);
          console.log(error);
          // return Observable.throw(error);
          }
          );
           
  
}
      





  
getJobServiceMetricsSubjectSearch(search_model) {
  // clear all the data arrays first
  this.job_metrix_join_results = [];
  this.subject_service_metrix_search = [];
  this.metric_1_data_join = [];
  this.metric_2_data_join = [];
  this.metric_3_data_join = [];
  this.metric_4_data_join = [];
  this.metric_5_data_join = [];
  this.metric_6_data_join = [];
  this.metric_1_data = [];
  this.metric_2_data = [];
  this.metric_3_data = [];
  this.metric_4_data = [];
  this.metric_5_data = [];
  this.metric_6_data = [];
  this.metric_1 = null;
  this.metric_2 = null;
  this.metric_3 = null;
  this.metric_4 = null;
  this.metric_5 = null;
  this.metric_6 = null;
  // this.company_report_graph = this.company_report_graph.destroy();
//  this.company_report_graph.chart.destroy();

  // search_model.brand_type_id = 3;
  // search_model.access_level = 5;
  this._demoService.getJobServiceMetricsSubjectSearch(search_model)
  .pipe(
    this.toastr.observe({
      loading: 'Checking Global Metrics...',
      success: '🚀',
      error: '...😡...'
   })
   )
  .subscribe(
    data => { this.subject_service_metrix_search = data;
     let res = data[0];
      // pass so that the dates are correct in Sync
      // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
      this.subject_service_metrix_search_results = DataUtil.parse.parseJson(data);
// get the users as well and join the records together

// let metic_1 = this.subject_service_metrix_search.filter((item) => item.nl_count)
// .map((item) => +item.nl_count)
// .reduce((sum, current) => sum + current);




    // To set two dates to two variables 
    // let date1 = new Date("06/30/2019"); 
  	// let date2 = new Date("07/30/2019"); 
  
    // let Time = date2.getTime() - date1.getTime();
    // let Days = Time / (1000 * 3600 * 24); // Diference in Days


                // this.getReportUsersSearch(search_model);

                // now how to join two arrays of objects.
                // maybe pass results in to a new model.

                // Count items of brand search to loop through
                let  count_of_items = Object.keys(this.subject_service_metrix_search).length;
                // now loop and push to join model
                // let date = new Date(res.created_date * 1000);
                // let job_start_date = new Date(date);

                let Time;
                let date1;
                let date2;
                let metric_1;
                let metric_1_words;
                let metric_2;
                let metric_2_words;
                let metric_3;
                let metric_3_words;
                let metric_4;
                let metric_4_words;
                let metric_5;
                let metric_5_words;
                let metric_6;
                let metric_6_words;
                let metric_1_date;
                let metric_1_date_format;
                let metric_2_date;
                let metric_3_date;
                let metric_4_date;
                let metric_5_date;
                let metric_6_date;

// ... Metric 1
      // this.metric_1_data = this.subject_service_metrix_search.filter((sbi)=>(sbi.service_number === '1'));
      // date1 = new Date(this.metric_1_data[0].created_date * 1000);
      // // date2 = new Date(metric_1_data[0].date_service);
      // date2 = new Date(this.metric_1_data[0].date_service);
      // Time = date2.getTime() - date1.getTime(); // milliseconds // reversed as bigger date so there are not negative
      // metric_1 = Time;
      // metric_1_date = date2;
      // metric_1_date_format = this.datepipe.transform(date2, 'yyyy-MM-dd');
      // console.log('metric_1_date: ', metric_1_date);
      // metric_1_words = this.dhm( Time );

      // this.metric_1_date_1 = new Date(this.metric_1_data[0].created_date * 1000);
      // this.metric_1_date_2 = new Date(this.metric_1_data[0].date_service);
      // this.metric_1 = this.metric_1_date_2.getTime() - this.metric_1_date_1.getTime(); // milliseconds // bigger date first so no negatives
      // this.metric_1_words = this.dhm( this.metric_1 );
      // this.metric_1_who_service = this.metric_1_data[0].who_service;
      // this.metric_1_subject_service_id = this.metric_1_data[0].subject_service_id;
      // this.metric_1_subject_id = this.metric_1_data[0].subject_id;
      // this.metric_1_subject_number = this.metric_1_data[0].subject_number;
      // this.metric_1_hours = this.returnHoursFunction(this.metric_1);
      // this.metric_1_text = 'Time to 1st Attempt on Subject';
      // this.metric_1_title = 'Metric 1';

// console.log('var: ', metric_1_data[0].created_date);
// console.log('metric_data: ', JSON.stringify(metric_1_data));


// ... Metric 1
this.metric_1_data = this.subject_service_metrix_search.filter((sbi)=>(sbi.service_number === '1'));
if (JSON.stringify(this.metric_1_data) !== '[]') { // only load if data

  this.metric_1_date_1 = new Date(this.metric_1_data[0].created_date * 1000);
 
  // For new date formates
// if(this.metric_1_data[0].created_date.toString().endsWith("Z")){
//   this.metric_1_date_1 = new Date(this.metric_1_data[0].created_date ); // so if created_date ends in Z do this...
// }
// console.log('Date Ends With Z : ' + this.metric_1_date_1.toString().endsWith("Z")); // works must conver to a string first very important.

 
  let count_date_string = this.metric_1_data[0].created_date.length;
  console.log('Created Date Length: ' + count_date_string)
  if(count_date_string == 13){
    let str = this.metric_1_data[0].created_date.toString();
    // str.substring(0, str.length-3);
    console.log('Updated Date: ' + str.substring(0, str.length-3))
   let modified_date = str.substring(0, str.length-3); // removes the last three chars if longer than 10 or = 13
   this.metric_1_date_1 = new Date(modified_date * 1000);
  }

  // if undefined then is the javascript date I think...
  if(count_date_string == undefined){
    this.metric_1_date_1 = new Date(this.metric_1_data[0].created_date)
  }
  

this.metric_1_date_2 = new Date(this.metric_1_data[0].date_service);
this.metric_1 = this.metric_1_date_2.getTime() - this.metric_1_date_1.getTime(); // milliseconds // bigger date first so no negatives
console.log('job_id', this.metric_1_data[0].job_id);
console.log('created_date ', this.metric_1_data[0].created_date);
console.log('metric 1 date', this.metric_1_date_1);
console.log('metric 2 date', this.metric_1_date_2);
console.log('metric 1', this.metric_1);



// try setting an array and do a ngfor loop in template.
this.metric_1_data_join = [{
  ...this.metric_1_data[0],
  metric_1_date_1: this.metric_1_date_1,
  metric_1_date_2: this.metric_1_date_2,
  metric_1: this.metric_1, // milliseconds // bigger date first so no negatives
  metric_1_words: this.dhm( this.metric_1 ),
  metric_1_who_service: this.metric_1_data[0].who_service,
  metric_1_hours: this.returnHoursFunction(this.metric_1),
  metric_1_text: 'Time to 1st Attempt on Subject',
  metric_1_title: 'Metric 1'
}];
}// end if




// ... Metric 2
this.metric_2_data = this.subject_service_metrix_search.filter((sbi)=>(sbi.service_number === '2'));
// if (JSON.stringify(this.metric_2_data) !== '[]') { // only load if data
if (this.metric_2_data.length !== 0) { // only load if data
this.metric_2_date_1 = new Date(this.metric_2_data[0].created_date * 1000);


  let count_date_string = this.metric_2_data[0].created_date.length;
  console.log('Created Date Length: ' + count_date_string)
  if(count_date_string == 13){
    let str = this.metric_2_data[0].created_date.toString();
    // str.substring(0, str.length-3);
    console.log('Updated Date: ' + str.substring(0, str.length-3))
  let modified_date = str.substring(0, str.length-3); // removes the last three chars if longer than 10 or = 13
  this.metric_2_date_1 = new Date(modified_date * 1000);
  }

  // if undefined then is the javascript date I think...
  if(count_date_string == undefined){
    this.metric_2_date_1 = new Date(this.metric_2_data[0].created_date)
  }



this.metric_2_date_2 = new Date(this.metric_2_data[0].date_service);
this.metric_2 = this.metric_2_date_2.getTime() - this.metric_2_date_1.getTime(); // milliseconds // bigger date first so no negatives

// try setting an array and do a ngfor loop in template.
this.metric_2_data_join = [{
  ...this.metric_2_data[0],
  metric_2_date_1: this.metric_2_date_1,
  metric_2_date_2: this.metric_2_date_2,
  metric_2: this.metric_2, // milliseconds // bigger date first so no negatives
  metric_2_words: this.dhm( this.metric_2 ),
  metric_2_who_service: this.metric_2_data[0].who_service,
  metric_2_hours: this.returnHoursFunction(this.metric_2),
  metric_2_text: 'Time to 2nd Attempt on Subject',
  metric_2_title: 'Metric 2'
}];
} // end if

// date1 = new Date(this.metric_2_data[0].created_date * 1000);
// // date2 = new Date(metric_2_data[0].date_service);
// date2 = new Date(this.metric_2_data[0].date_service);
// Time = date1.getTime() - date2.getTime(); // milliseconds
// metric_2 = Time;
// metric_2_date = this.datepipe.transform(date2, 'yyyy-MM-dd');
// metric_2_words = this.dhm( Time );





// ... Metric 3 (Calculation between)
this.metric_3_data = this.subject_service_metrix_search.filter((sbi)=>(sbi.service_number === '2'));
if (JSON.stringify(this.metric_3_data) !== '[]') { // only load if data
this.metric_3_date_1 = new Date(this.metric_1);
this.metric_3_date_2 = new Date(this.metric_2);
this.metric_3 = this.metric_3_date_2.getTime() - this.metric_3_date_1.getTime(); // milliseconds // bigger date first so no negatives

// try setting an array and do a ngfor loop in template.
this.metric_3_data_join = [{
  ...this.metric_3_data[0],
  metric_3_date_1: this.metric_3_date_1,
  metric_3_date_2: this.metric_3_date_2,
  metric_3: this.metric_3, // milliseconds // bigger date first so no negatives
  metric_3_words: this.dhm( this.metric_3 ),
  metric_3_who_service: this.metric_3_data[0].who_service,
  metric_3_hours: this.returnHoursFunction(this.metric_3),
  metric_3_text: 'Time between 1st & 2nd Attempt on Subject',
  metric_3_title: 'Metric 3'
}];
} // end if

// let metric_3_data = this.subject_service_metrix_search.filter((sbi)=>(sbi.service_number === '3')); // no filter required
// date1 = new Date(metric_1);
// date2 = new Date(metric_2);
// Time = date1.getTime() - date2.getTime(); // milliseconds
// metric_3 = Time;
// metric_3_date = metric_2_date;
// metric_3_words = this.dhm( metric_3 );



// ... Metric 4
this.metric_4_data = this.subject_service_metrix_search.filter((sbi)=>(sbi.service_number === '3')); // attempt 3
if (JSON.stringify(this.metric_4_data) !== '[]') { // only load if data
this.metric_4_date_1 = new Date(this.metric_4_data[0].created_date * 1000);


    let count_date_string = this.metric_4_data[0].created_date.length;
    console.log('Created Date Length: ' + count_date_string)
    if(count_date_string == 13){
      let str = this.metric_4_data[0].created_date.toString();
      // str.substring(0, str.length-3);
      console.log('Updated Date: ' + str.substring(0, str.length-3))
    let modified_date = str.substring(0, str.length-3); // removes the last three chars if longer than 10 or = 13
    this.metric_4_date_1 = new Date(modified_date * 1000);
    }

    // if undefined then is the javascript date I think...
    if(count_date_string == undefined){
      this.metric_4_date_1 = new Date(this.metric_4_data[0].created_date)
    }



this.metric_4_date_2 = new Date(this.metric_4_data[0].date_service);
this.metric_4 = this.metric_4_date_2.getTime() - this.metric_4_date_1.getTime(); // milliseconds // bigger date first so no negatives

// try setting an array and do a ngfor loop in template.
this.metric_4_data_join = [{
  ...this.metric_4_data[0],
  metric_4_date_1: this.metric_4_date_1,
  metric_4_date_2: this.metric_4_date_2,
  metric_4: this.metric_4, // milliseconds // bigger date first so no negatives
  metric_4_words: this.dhm( this.metric_4 ),
  metric_4_who_service: this.metric_4_data[0].who_service,
  metric_4_hours: this.returnHoursFunction(this.metric_4),
  metric_4_text: 'Time to 3rd Attempt on Subject.',
  metric_4_title: 'Metric 4'
}];
} // end if

// let metric_4_data = this.subject_service_metrix_search.filter((sbi)=>(sbi.service_number === '3')); // no filter required
// date1 = new Date(metric_4_data[0].created_date * 1000);
// date2 = new Date(metric_4_data[0].date_service);
// Time = date1.getTime() - date2.getTime(); // milliseconds
// metric_4 = Time;
// metric_4_date = this.datepipe.transform(date2, 'yyyy-MM-dd');
// metric_4_words = this.dhm( metric_4 );




// ... Metric 5 (Calculation between)
this.metric_5_data = this.subject_service_metrix_search.filter((sbi)=>(sbi.service_number === '3'));
if (JSON.stringify(this.metric_5_data) !== '[]') { // only load if data
this.metric_5_date_1 = new Date(this.metric_3);
this.metric_5_date_2 = new Date(this.metric_4);
this.metric_5 = this.metric_5_date_2.getTime() - this.metric_5_date_1.getTime(); // milliseconds // bigger date first so no negatives

// try setting an array and do a ngfor loop in template.
this.metric_5_data_join = [{
  ...this.metric_5_data[0],
  metric_5_date_1: this.metric_5_date_1,
  metric_5_date_2: this.metric_5_date_2,
  metric_5: this.metric_5, // milliseconds // bigger date first so no negatives
  metric_5_words: this.dhm( this.metric_5 ),
  metric_5_who_service: this.metric_5_data[0].who_service,
  metric_5_hours: this.returnHoursFunction(this.metric_5),
  metric_5_text: 'Time between 2nd & 3rd Attempt on Subject',
  metric_5_title: 'Metric 5'
}];
} // end if

// date1 = new Date(metric_3);
// date2 = new Date(metric_4);
// Time = date1.getTime() - date2.getTime(); // milliseconds
// metric_5 = Time;
// metric_5_date = metric_4_date;
// metric_5_words = this.dhm( metric_5 );




// ... Metric 4
this.metric_6_data = this.subject_service_metrix_search.filter((sbi)=>(sbi.service_number === '1')); // attempt 1
if (JSON.stringify(this.metric_6_data) !== '[]') { // only load if data
  // this.metric_6_date_1 = new Date(this.metric_6_data[0].created_date * 1000);
  this.metric_6_date_1 = new Date(this.metric_6_data[0].created_date * 1000);

              let count_date_string = this.metric_6_data[0].created_date.length;
              console.log('Created Date Length: ' + count_date_string)
              if(count_date_string == 13){
                let str = this.metric_6_data[0].created_date.toString();
                // str.substring(0, str.length-3);
                console.log('Updated Date: ' + str.substring(0, str.length-3))
              let modified_date = str.substring(0, str.length-3); // removes the last three chars if longer than 10 or = 13
              this.metric_6_date_1 = new Date(modified_date * 1000);
              }

              // if undefined then is the javascript date I think...
              if(count_date_string == undefined){
                this.metric_6_date_1 = new Date(this.metric_6_data[0].created_date)
              }




this.metric_6_date_2 = new Date(this.metric_6_data[0].updated_date * 1000);

          let count_date_string2 = this.metric_6_data[0].updated_date.length;
          console.log('Created Date Length: ' + count_date_string2)
          if(count_date_string2 == 13){
            let str2 = this.metric_6_data[0].updated_date.toString();
            // str.substring(0, str.length-3);
            console.log('Updated Date: ' + str2.substring(0, str2.length-3))
          let modified_date = str2.substring(0, str2.length-3); // removes the last three chars if longer than 10 or = 13
          this.metric_6_date_2 = new Date(modified_date * 1000);
          }

          if(count_date_string2 == 0){
            this.metric_6_date_2 = this.gfunc.today // chaged Metric
          }
          // if undefined then is the javascript date I think...
          if(count_date_string2 == undefined){
            this.metric_6_date_2 = this.metric_6_data[0].updated_date
            // this.metric_6_date_2 = this.gfunc.today // chaged Metric
          }


          // this.metric_6_date_2 = this.gfunc.today // chaged Metric

this.metric_6 = this.metric_6_date_2.getTime() - this.metric_6_date_1.getTime(); // milliseconds // bigger date first so no negatives
console.log('job_id', this.metric_6_data[0].job_id);
console.log('created_date ', this.metric_6_data[0].created_date);
console.log('updated_date ', this.metric_6_data[0].updated_date);
console.log('metric 1 date', this.metric_6_date_1);
console.log('metric 2 date', this.metric_6_date_2);
console.log('metric 6', this.metric_6);



// try setting an array and do a ngfor loop in template.
this.metric_6_data_join = [{
  ...this.metric_6_data[0],
  metric_6_date_1: this.metric_6_date_1,
  metric_6_date_2: this.metric_6_date_2,
  metric_6: this.metric_6, // milliseconds // bigger date first so no negatives
  metric_6_words: this.dhm( this.metric_6 ),
  metric_6_who_service: this.metric_6_data[0].who_service,
  metric_6_hours: this.returnHoursFunction(this.metric_6),
  metric_6_text: 'Time Job Start to Closed (or last updated if not yet closed).',
  metric_6_title: 'Metric 6'
}];
} // end if

// let metric_6_data = this.subject_service_metrix_search.filter((sbi)=>('6' === '6')); //
// date1 = new Date(metric_6_data[0].created_date * 1000);
// date2 = new Date(metric_6_data[0].updated_date * 1000);
// Time = date1.getTime() - date2.getTime(); // milliseconds
// metric_6 = Time;
// metric_6_date = this.datepipe.transform(date2, 'yyyy-MM-dd');
// metric_6_words = this.dhm( metric_6 );
// Time Since Last Updated Or Closed. (If not as yet closed.)

// let metric_4_data = this.subject_service_metrix_search.filter((sbi)=>(sbi.service_number === '4')); // 
// let metric_5_data = this.subject_service_metrix_search.filter((sbi)=>(sbi.service_number === '5')); //
// let metric_6_data = this.subject_service_metrix_search.filter((sbi)=>(sbi.service_number === '6')); //


// this.job_metrix_join_results = [{
//   ...this.subject_service_metrix_search[0],
//   metric_1: metric_1,
//   metric_1_words: metric_1_words,
//   metric_2: metric_2,
//   metric_2_words: metric_2_words,
//   metric_3: metric_3,
//   metric_3_words: metric_3_words,
//   metric_4: metric_4,
//   metric_4_words: metric_4_words,
//   metric_5: metric_5,
//   metric_5_words: metric_5_words,
//   metric_6: metric_6,
//   metric_6_words: metric_6_words,
//   job_start_date: job_start_date,
// }];



this.company_report_graph = c3.generate({
  bindto: '#company_report_graph',
data: {
 x: 'x',
 labels: false,
//        xFormat: '%Y%m%d', // 'xFormat' can be used as custom format of 'x'
 columns: [
     // tslint:disable-next-line:max-line-length
    //  ['x', metric_1_date, metric_2_date, metric_3_date, metric_4_date, metric_5_date, metric_6_date],
    ['x',  'Metric 1: 1st Attempt on ', 'Metric 2: 2nd Attempt ', 'Metric 3: Time between 1st - 2nd Attempt', 'Metric 4: 3rd Attempt ', 'Metric 5: Time between 2nd - 3rd Attempt', 'Metric 6: Filed to Closed - (or last updated)'],
//            ['x', '20130101', '20130102', '20130103', '20130104', '20130105', '20130106'],
     // tslint:disable-next-line:max-line-length
    //  ['Agent A Subject Attempt - Metrics',  this.returnHoursFunction(this.metric_1), this.returnHoursFunction(metric_2), this.returnHoursFunction(metric_3), this.returnHoursFunction(metric_4), this.returnHoursFunction(metric_5), this.returnHoursFunction(metric_6)],
     ['Agent/Subject Attempt - Metrics',  this.convertMsToHM(this.metric_1), this.convertMsToHM(this.metric_2), this.convertMsToHM(this.metric_3), this.convertMsToHM(this.metric_4), this.convertMsToHM(this.metric_5), this.convertMsToHM(this.metric_6)],
    //  ['AM2 - Metric 2', 5],
    //  ['AM3 - Metric 3', 3],
    //  ['AM4 - Metric 4', 1.5],
    //  ['AM5 - Metric 5', 1.5],
    //  ['AM6 - Metric 6', 21.5],
 ],
 type: 'spline', // bar,
//  onclick: function(d){
//  console.log(d);
//  },
},
bar: {
  width: {
      ratio: 0.5 // this makes bar width 50% of length between ticks
  }
  // or
  //width: 100 // this makes bar width 100px
},
// axis: {
//  x: {
//      type: 'timeseries',
//      tick: {
//         format: '%Y-%m-%d',
        // values: ['Metric 1', 'Metric 2','Metric 1', 'Metric 2','Metric 1', 'Metric 2','Metric 1', 'Metric 2']
//      }
//  }
// },
axis: {
  x: {
      type: 'category',
      tick: {
          // rotate: 75,
          multiline: true
      },
      height: 100,
      label: 'Metric'
  },
  y: {
    label: 'Hours.Mins'
  },
  // y2: {
  //   show: true,
  //   label: {
  //     text: 'Days',
  //     position: 'outer-middle'
  //   },
  //   max: 24,
  //   min: 0
  // }
},
grid: {
  y: {
      lines: [
          // {value: 50, text: 'Label 50 for y'},
          {value: 500, text: 'Attempt Time Excessive (HRS)', axis: 'y', position: 'start'},
          // {value: 350, text: 'Label 350 for y', position: 'middle'}
      ]
  }
},



});





                for(let i=0; i < count_of_items; i++) {
                  let res = this.subject_service_metrix_search_results[i];

// console.log('date 1:', res.created_date);
// console.log('created:', res.created);

                  let date = new Date(res.created_date * 1000);
                  let job_start_date = new Date(date);
                  // let date2 = new Date(res.date_service);

                  // console.log('Date 1: ', date1);
                  // console.log('Date 2: ', date2);
                

    


                  // let Time = date1.getTime() - date2.getTime(); // milliseconds
                  // let Days = Time / (1000 * 3600 * 24); // Diference in Days
                  // let millisecondsPerDay = 1000 * 60 * 60 * 24;
                  // let num =  Days / millisecondsPerDay; // days as a decimal.
                  //  metric_1 = Time;
                  //  metric_1_words = this.dhm( Time );


                  // console.log('Days Calc: ', this.dhm( Time ) );

                  // if(search_model.service_number == 2) {
                  // metric_2 = Time;
                  // metric_2_words = this.dhm( Time );
                  // }

                  // if(search_model.service_number == 2) {
                  //   let date1 = new Date(metric_1);
                  //   let date2 = new Date(metric_2);
                  //   metric_3 = date1.getTime() - date2.getTime();
                  //   metric_3_words = this.dhm( metric_3 );
                  //   console.log('metric_3: ', metric_3);
                  //   }









                    
                    // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
            this.job_metrix_join_results.push({
               ...this.subject_service_metrix_search[i],
              //  metric_1: metric_1,
              //  metric_1_words: metric_1_words,
              //  metric_2: metric_2,
              //  metric_2_words: metric_2_words,
              //  metric_3: metric_3,
              //  metric_3_words: metric_3_words,
              //  metric_4: metric_4,
              //  metric_4_words: metric_4_words,
              //  metric_5: metric_5,
              //  metric_5_words: metric_5_words,
              //  metric_6: metric_6,
              //  metric_6_words: metric_6_words,
              //  job_start_date: job_start_date,
              });

                } // end brands loop.

              //  this.job_metrix_join_results = this.job_metrix_join_results;

     this.grid.refresh();
  
      },
      error => {
      console.error('Error Loading !' + error.error);
      console.log(error);
      // return Observable.throw(error);
      }
      );
       

}






confirmEnding(string, target) {
 
  return string.substr(-target.length) === target;
}

strEndsWith(str, suffix) {
  return str.match(suffix+"$")==suffix;
}


getJobServiceMetricsSubjectSearchFull(search_model) {

  this.creating_search_data = 1;


  // clear all the data arrays first
  this.job_metrix_join_results = [];
  this.subject_service_metrix_search_full = [];
  this.subject_service_metrix_search_full_results = [];
  this.metric_1_data_join = [];
  this.metric_2_data_join = [];
  this.metric_3_data_join = [];
  this.metric_4_data_join = [];
  this.metric_5_data_join = [];
  this.metric_6_data_join = [];
  this.metric_1_data = [];
  this.metric_2_data = [];
  this.metric_3_data = [];
  this.metric_4_data = [];
  this.metric_5_data = [];
  this.metric_6_data = [];
  this.metric_1 = null;
  this.metric_2 = null;
  this.metric_3 = null;
  this.metric_4 = null;
  this.metric_5 = null;
  this.metric_6 = null;

  this.metric_1_count = []; // start of adverages and counts badges
  this.metric_2_count = [];
  this.metric_3_count = [];
  this.metric_4_count = [];
  this.metric_5_count = [];
   this.metric_6_count = [];

   this.arrayOfLinks = [];

this.metric_1_adverage_time_taken = null;
this.metric_1_adverage_time_taken_words = null;
this.metric_2_adverage_time_taken = null;
this.metric_2_adverage_time_taken_words = null;
this.metric_3_adverage_time_taken = null;
this.metric_3_adverage_time_taken_words = null;
this.metric_4_adverage_time_taken = null;
this.metric_4_adverage_time_taken_words = null;
this.metric_5_adverage_time_taken = null;
this.metric_5_adverage_time_taken_words = null;
this.metric_6_adverage_time_taken = null;
this.metric_6_adverage_time_taken_words = null;

  // this.company_report_graph = this.company_report_graph.destroy();
//  this.company_report_graph.chart.destroy();





// I doubled up this below and now seaerchs are refreshed everytime!!!! :)
this.agent_metrics_chart_full = c3.generate({
  bindto: '#agent_metrics_chart_full',
  size: {
    height: 750,
    // width: 480
},
data: {
 x: 'x',
 labels: true,
//        xFormat: '%Y%m%d', // 'xFormat' can be used as custom format of 'x'
 columns: [
     // tslint:disable-next-line:max-line-length
    //  ['x', metric_1_date, metric_2_date, metric_3_date, metric_4_date, metric_5_date, metric_6_date],
    ['x',  'Metric 1: 1st Attempt on ', 'Metric 2: 2nd Attempt ', 'Metric 3: Time between 1st - 2nd Attempt', 'Metric 4: 3rd Attempt ', 'Metric 5: Time between 2nd - 3rd Attempt', 'Metric 6: Time Job filed to Subject Closed'],
//            ['x', '20130101', '20130102', '20130103', '20130104', '20130105', '20130106'],
     // tslint:disable-next-line:max-line-length
    //  ['Agent A Subject Attempt - Metrics',  this.returnHoursFunction(this.metric_1), this.returnHoursFunction(metric_2), this.returnHoursFunction(metric_3), this.returnHoursFunction(metric_4), this.returnHoursFunction(metric_5), this.returnHoursFunction(metric_6)],
           ['SYSTEM AVERAGE',  this.convertMsToHM(this.metric_1), this.convertMsToHM(this.metric_2), this.convertMsToHM(this.metric_3), this.convertMsToHM(this.metric_4), this.convertMsToHM(this.metric_5), this.convertMsToHM(this.metric_6)],
    //  ['AM2 - Metric 2', 5],
    //  ['AM3 - Metric 3', 3],
    //  ['AM4 - Metric 4', 1.5],
    //  ['AM5 - Metric 5', 1.5],
    //  ['AM6 - Metric 6', 21.5],
 ],
 type: 'line', // bar
 // ::@http://bl.ocks.org/akulmehta/87f4903a4686deb8285381b8e816ce4d
 onclick: function(d){
  // console.log(this.arrayOfLinks[d.x]);
  console.log(d);
  // console.log('Subject_service_id: ', this.arrayOfLinks[d.x].subject_service_id);
  // console.log('Subject_number: ', this.arrayOfLinks[d.x].subject.number);
console.log(arrayOfLinks[d.x]);

 // make all the bar opacity 0.1
    //  d3.selectAll('.c3-shape').style('opacity', 0.1);
    //  let k = '.c3-shape-' + d.index;
    //  // make the clicked bar opacity 1
    //  d3.selectAll(k).style('opacity', 1);



}
},
bar: {
  width: {
      ratio: 0.5 // this makes bar width 50% of length between ticks
  }
  // or
  //width: 100 // this makes bar width 100px
},
// axis: {
//  x: {
//      type: 'timeseries',
//      tick: {
//         format: '%Y-%m-%d',
        // values: ['Metric 1', 'Metric 2','Metric 1', 'Metric 2','Metric 1', 'Metric 2','Metric 1', 'Metric 2']
//      }
//  }
// },
axis: {
  x: {
      type: 'category',
      tick: {
          // rotate: 75,
          multiline: true
      },
      height: 100,
      label: 'Metric'
  },
  y: {
    label: 'Hours.Mins',
  }
},
grid: {
  y: {
      lines: [
          // {value: 50, text: 'Label 50 for y'},
          {value: 500, text: 'Attempt Time Excessive (HRS)', axis: 'y', position: 'start'},
          // {value: 350, text: 'Label 350 for y', position: 'middle'}
      ]
  }
},
// legend: {
//   item: {
//     // this selects the current rather than deselects
//        onclick: function (d) { 
//               this.div1.focus(d);
//               this.select(d);
//         },
//         onmouseout: function(d){
//               // prevent deselect onmouseout
//         }
//   }
// }
});


this.agent_metrics_chart_full.flush(); // redraw the graph
// this.arrayOfLinks = [
//   "http://google.com",
//   "http://bing.com",
//   "http://duckduckgo.com",
//   "http://yahoo.com",
//   "http://msn.com",
//   "http://stackoverflow.com",
// ];



// :: this was correct format for the function in the c3.js graph
let arrayOfLinks = [
'121', '142', 163, '124', '145', 166, '127', '148', 169
];

// let arrayOfLinks = [
// ...this.arrayOfLinks
// ];












// getJobServiceMetricsSubjectSearchActivity
  // search_model.brand_type_id = 3;
  // search_model.access_level = 5;
  // this._demoService.getJobServiceMetricsSubjectSearch(search_model).subscribe(
    this._demoService.getJobServiceMetricsSubjectSearch(search_model)
    .pipe(
      this.toastr.observe({
        loading: 'Checking Global Metrics...',
        success: '🚀',
        error: '...😡...'
     })
     )
    .subscribe(
    data => { this.subject_service_metrix_search_full = data;
     let res = data[0];
      // pass so that the dates are correct in Sync
      // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
      this.subject_service_metrix_search_full_results = DataUtil.parse.parseJson(data);
// get the users as well and join the records together

// let metic_1 = this.subject_service_metrix_search_full.filter((item) => item.nl_count)
// .map((item) => +item.nl_count)
// .reduce((sum, current) => sum + current);

this.agent_metrics_chart_full = c3.generate({
  bindto: '#agent_metrics_chart_full',
  size: {
    height: 750,
    // width: 480
},
data: {
 x: 'x',
 labels: true,
//        xFormat: '%Y%m%d', // 'xFormat' can be used as custom format of 'x'
 columns: [
     // tslint:disable-next-line:max-line-length
    //  ['x', metric_1_date, metric_2_date, metric_3_date, metric_4_date, metric_5_date, metric_6_date],
    ['x',  'Metric 1: 1st Attempt on ', 'Metric 2: 2nd Attempt ', 'Metric 3: Time between 1st - 2nd Attempt', 'Metric 4: 3rd Attempt ', 'Metric 5: Time between 2nd - 3rd Attempt', 'Metric 6: Time Job filed to Subject Closed'],
//            ['x', '20130101', '20130102', '20130103', '20130104', '20130105', '20130106'],
     // tslint:disable-next-line:max-line-length
    //  ['Agent A Subject Attempt - Metrics',  this.returnHoursFunction(this.metric_1), this.returnHoursFunction(metric_2), this.returnHoursFunction(metric_3), this.returnHoursFunction(metric_4), this.returnHoursFunction(metric_5), this.returnHoursFunction(metric_6)],
           ['SYSTEM AVERAGE',  this.convertMsToHM(this.metric_1), this.convertMsToHM(this.metric_2), this.convertMsToHM(this.metric_3), this.convertMsToHM(this.metric_4), this.convertMsToHM(this.metric_5), this.convertMsToHM(this.metric_6)],
    //  ['AM2 - Metric 2', 5],
    //  ['AM3 - Metric 3', 3],
    //  ['AM4 - Metric 4', 1.5],
    //  ['AM5 - Metric 5', 1.5],
    //  ['AM6 - Metric 6', 21.5],
 ],
 type: 'line', // bar
 // ::@http://bl.ocks.org/akulmehta/87f4903a4686deb8285381b8e816ce4d
 onclick: function(d){
  // console.log(this.arrayOfLinks[d.x]);
  console.log(d);
  // console.log('Subject_service_id: ', this.arrayOfLinks[d.x].subject_service_id);
  // console.log('Subject_number: ', this.arrayOfLinks[d.x].subject.number);
console.log(arrayOfLinks[d.x]);

 // make all the bar opacity 0.1
    //  d3.selectAll('.c3-shape').style('opacity', 0.1);
    //  let k = '.c3-shape-' + d.index;
    //  // make the clicked bar opacity 1
    //  d3.selectAll(k).style('opacity', 1);



}
},
bar: {
  width: {
      ratio: 0.5 // this makes bar width 50% of length between ticks
  }
  // or
  //width: 100 // this makes bar width 100px
},
// axis: {
//  x: {
//      type: 'timeseries',
//      tick: {
//         format: '%Y-%m-%d',
        // values: ['Metric 1', 'Metric 2','Metric 1', 'Metric 2','Metric 1', 'Metric 2','Metric 1', 'Metric 2']
//      }
//  }
// },
axis: {
  x: {
      type: 'category',
      tick: {
          // rotate: 75,
          multiline: true
      },
      height: 100,
      label: 'Metric'
  },
  y: {
    label: 'Hours.Mins',
  }
},
grid: {
  y: {
      lines: [
          // {value: 50, text: 'Label 50 for y'},
          {value: 500, text: 'Attempt Time Excessive (HRS)', axis: 'y', position: 'start'},
          // {value: 350, text: 'Label 350 for y', position: 'middle'}
      ]
  }
},
// legend: {
//   item: {
//     // this selects the current rather than deselects
//        onclick: function (d) { 
//               this.div1.focus(d);
//               this.select(d);
//         },
//         onmouseout: function(d){
//               // prevent deselect onmouseout
//         }
//   }
// }
});


    // To set two dates to two variables 
    // let date1 = new Date("06/30/2019"); 
  	// let date2 = new Date("07/30/2019"); 
  
    // let Time = date2.getTime() - date1.getTime();
    // let Days = Time / (1000 * 3600 * 24); // Diference in Days


                // this.getReportUsersSearch(search_model);

                // now how to join two arrays of objects.
                // maybe pass results in to a new model.

                // Count items of brand search to loop through
                let  count_of_items = Object.keys(this.subject_service_metrix_search_full).length;
                console.log('Count of Subject Attempts: ', count_of_items);
                // now loop and push to join model
                // let date = new Date(res.created_date * 1000);
                // let job_start_date = new Date(date);

this.count_of_items = count_of_items;

          //      https://www.digitalocean.com/community/tutorials/for-loops-for-of-loops-and-for-in-loops-in-javascript
//setting a max


// if(count_of_items > 2000){
//   count_of_items = 2000; // NEW AX SET
// }


                let Time;
                let date1;
                let date2;
                let metric_1;
                let metric_1_words;
                let metric_2;
                let metric_2_words;
                let metric_3;
                let metric_3_words;
                let metric_4;
                let metric_4_words;
                let metric_5;
                let metric_5_words;
                let metric_6;
                let metric_6_words;
                let metric_1_date;
                let metric_1_date_format;
                let metric_2_date;
                let metric_3_date;
                let metric_4_date;
                let metric_5_date;
                let metric_6_date;











                for(let i=0; i < count_of_items; i++) {
                  let res2 = this.subject_service_metrix_search_full_results[i];

// console.log('date 1:', res.created_date);
// console.log('created:', res.created);

                  // let date = new Date(res2.created_date * 1000);
                  // let job_start_date = new Date(date);
                  // let date1 = new Date(res2.created_date * 1000);
                  // let date2 = new Date(res2.date_service);

                  // // console.log('Date 1: ', date1);
                  // // console.log('Date 2: ', date2);
                

    


                  // let Time = date1.getTime() - date2.getTime(); // milliseconds
                  // let Days = Time / (1000 * 3600 * 24); // Diference in Days
                  // let millisecondsPerDay = 1000 * 60 * 60 * 24;
                  // let num =  Days / millisecondsPerDay; // days as a decimal.
                  //  metric_1 = Time;
                  //  metric_1_words = this.dhm( Time );

// Reset every loop.
this.metric_1 = 0;
this.metric_2 = 0;
this.metric_3 = 0;
this.metric_4 = 0;
this.metric_5 = 0;
this.metric_6 = 0;
// this.metric_2_date_1 = null;
// this.metric_2_date_2 = null;


                  // console.log('Days Calc: ', this.dhm( Time ) );

// ... Metric 1
// console.log('res.service_number: ', res.service_number);
    // if (this.subject_service_metrix_search_full_results[i].service_number == 1) {
    //   console.log('CreatedDate1 ', this.subject_service_metrix_search_full_results[i].created_date * 1000);
    // date1 = new Date(this.subject_service_metrix_search_full_results[i].created_date * 1000);
    // date2 = new Date(this.subject_service_metrix_search_full_results[i].date_service);
    // this.metric_1 = date2.getTime() - date1.getTime(); // milliseconds // bigger date first so no negatives
    // }
// date1 = new Date(res2.created_date * 1000);
// date2 = new Date(res2.date_service);
// metric_1 = date2.getTime() - date1.getTime(); // milliseconds // bigger date first so no negatives

// ... Metric 2
// console.log('full_service_number: ', this.subject_service_metrix_search_full_results[i].service_number);
// if (this.subject_service_metrix_search_full_results[i].service_number == '2') {
//   console.log('CreatedDate2 ', this.subject_service_metrix_search_full_results[i].created_date * 1000);
//   date1 = new Date(this.subject_service_metrix_search_full_results[i].created_date * 1000);
//   date2 = new Date(this.subject_service_metrix_search_full_results[i].date_service);
// this.metric_2 = date2.getTime() - date1.getTime(); // milliseconds // bigger date first so no negatives
// console.log('MEtric2 ', this.metric_2);
// console.log('Metric2 Format: ', this.convertMsToHM(this.metric_2));
// }
// ... Metric 3
// if (this.subject_service_metrix_search_full_results[i].service_number == 2) {
// date1 = new Date(this.metric_1);
// date2 = new Date(this.metric_2);
// this.metric_3 = date2.getTime() - date1.getTime(); // milliseconds // bigger date first so no negatives
// }
// ... Metric 4
// if (this.subject_service_metrix_search_full_results[i].service_number == 3) {
// date1 = new Date(this.subject_service_metrix_search_full_results[i].created_date * 1000);
// date2 = new Date(this.subject_service_metrix_search_full_results[i].date_service);
// this.metric_4 = date2.getTime() - date1.getTime(); // milliseconds // bigger date first so no negatives
// }
// ... Metric 5
// if (this.subject_service_metrix_search_full_results[i].service_number == 3) {
// date1 = new Date(metric_3);
// date2 = new Date(metric_4);
// this.metric_5 = date2.getTime() - date1.getTime(); // milliseconds // bigger date first so no negatives
// }
// ... metric 6 (only closed)
// console.log('Status: ', this.subject_service_metrix_search_full_results[i].job_status);
// if (this.subject_service_metrix_search_full_results[i].job_status === 'CLOSED') {
// date1 = new Date(this.subject_service_metrix_search_full_results[i].created_date * 1000);
// date2 = new Date(this.subject_service_metrix_search_full_results[i].updated_date * 1000);
// this.metric_6 = date2.getTime() - date1.getTime(); // milliseconds // bigger date first so no negatives
// }

                  // if(res2.service_number === 2) {
                  // metric_2 = Time;
                  // metric_2_words = this.dhm( Time );
                  // console.log('metric_2: ', metric_2);
                  // }

                  // if(res2.service_number === 2) {
                  //   let date1 = new Date(metric_1);
                  //   let date2 = new Date(metric_2);
                  //   metric_3 = date1.getTime() - date2.getTime();
                  //   metric_3_words = this.dhm( metric_3 );
                  //   console.log('metric_3: ', metric_3);
                  //   }




// ... Metric 1
// tslint:disable-next-line:max-line-length
this.metric_1_data = this.subject_service_metrix_search_full_results.filter((sbi)=>(sbi.service_number === '1' && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id));
if (this.metric_1_data.length != 0) { // only load if data
  // if (JSON.stringify(this.metric_1_data) !== '[]') { // only load if data

  

// BASIC FUCNTION TO CHECK IF ENDS IN Z... (Conversions when I changed the job_create date...... 2/2/24)

this.metric_1_date_1 = new Date(this.metric_1_data[0].created_date * 1000); //other wise old way do this....
        

        // // For new date formates
        // if(this.metric_1_data[0].created_date.toString().endsWith("Z")){
        //           this.metric_1_date_1 = new Date(this.metric_1_data[0].created_date ); // so if created_date ends in Z do this...
        //         }
        //  console.log('Date Ends With Z : ' + this.metric_1_date_1.toString().endsWith("Z")); // works must conver to a string first very important.


        // // For new date timestring formats that append the timezone.        
        // // 1701934777_646 //  more if string length now the last three digits are timezone remove to get correct date.... length = 13 - three ...
        // let count_date_string = this.metric_1_data[0].created_date.length;

        // // var str2 =  this.metric_1_date_1;
        // // console.log('String2: ' + str2);
        // // var count = 0;
        // // for (let i = 0; i < str2.length; i++) {
        // //   // console.log(i)
        // //     count++;
        // // }
        // // let count_date_string = count;

        // console.log('Created Date Length: ' + count_date_string)
        // if(count_date_string == 13){
        //   let str = this.metric_1_data[0].created_date.toString();
        //   // str.substring(0, str.length-3);
        //   console.log('Updated Date: ' + str.substring(0, str.length-3))
        //  let modified_date = str.substring(0, str.length-3); // removes the last three chars if longer than 10 or = 13
        //  this.metric_1_date_1 = new Date(modified_date * 1000);
        // }


        let count_date_string = this.metric_1_data[0].created_date.length;
        console.log('Created Date Length: ' + count_date_string)
        if(count_date_string == 13){
          let str = this.metric_1_data[0].created_date.toString();
          // str.substring(0, str.length-3);
          console.log('Updated Date: ' + str.substring(0, str.length-3))
         let modified_date = str.substring(0, str.length-3); // removes the last three chars if longer than 10 or = 13
         this.metric_1_date_1 = new Date(modified_date * 1000);
        }
      
        // if undefined then is the javascript date I think...
        if(count_date_string == undefined){
          this.metric_1_date_1 = new Date(this.metric_1_data[0].created_date)
        }



this.metric_1_date_2 = new Date(this.metric_1_data[0].date_service);
this.metric_1 = this.metric_1_date_2.getTime() - this.metric_1_date_1.getTime(); // milliseconds // bigger date first so no negatives
console.log('job_id', this.metric_1_data[0].job_id);
console.log('created_date ', this.metric_1_data[0].created_date);
console.log('metric 1 date', this.metric_1_date_1);
console.log('metric 2 date', this.metric_1_date_2);
console.log('metric 1', this.metric_1);

// try setting an array and do a ngfor loop in template.
this.metric_1_data_join = [{
  // ...this.metric_1_data[0],
  // metric_1_date_1: this.metric_1_date_1,
  // metric_1_date_2: this.metric_1_date_2,
  // metric_1: this.metric_1, // milliseconds // bigger date first so no negatives
  // metric_1_words: this.dhm( this.metric_1 ),
  // metric_1_who_service: this.metric_1_data[0].who_service,
  // metric_1_hours: this.returnHoursFunction(this.metric_1),
  metric_1_text: 'Total Attempts',
  metric_1_title: 'Metric A',
  metric_total_count: count_of_items, // 
}];

// if(!isNaN(this.metric_1)){this.metric_1 = 0}
// sets up the totals and metrics widgets (Do the rest of calulations ouside of loops.)
this.metric_1_count.push({
  metric_1_total: this.metric_1, // ms
});
this.arrayOfLinks.push(this.metric_1_data[0].subject_service_id);

// this.arrayOfLinks.push({
//   subject_service_id: this.metric_1_data[0].subject_service_id,
//   subject_id: this.metric_1_data[0].subject_id,
//   subject_name: this.metric_1_data[0].subject_name
// });


}// end if

// ... Metric 2
// tslint:disable-next-line:max-line-length
this.metric_2_data = this.subject_service_metrix_search_full_results.filter((sbi)=>(sbi.service_number === '2' && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id));
console.log('Metric2 data: ', JSON.stringify(this.metric_2_data));
// if (JSON.stringify(this.metric_2_data) !== '[]') { // only load if data
if (this.metric_2_data.length != 0) { 
this.metric_2_date_1 = new Date(this.metric_2_data[0].created_date * 1000);

  let count_date_string = this.metric_2_data[0].created_date.length;
  console.log('Created Date Length: ' + count_date_string)
  if(count_date_string == 13){
    let str = this.metric_2_data[0].created_date.toString();
    // str.substring(0, str.length-3);
    console.log('Updated Date: ' + str.substring(0, str.length-3))
  let modified_date = str.substring(0, str.length-3); // removes the last three chars if longer than 10 or = 13
  this.metric_2_date_1 = new Date(modified_date * 1000);
  }

  // if undefined then is the javascript date I think...
  if(count_date_string == undefined){
    this.metric_2_date_1 = new Date(this.metric_2_data[0].created_date)
  }

this.metric_2_date_2 = new Date(this.metric_2_data[0].date_service);
this.metric_2 = this.metric_2_date_2.getTime() - this.metric_2_date_1.getTime(); // milliseconds // bigger date first so no negatives

// try setting an array and do a ngfor loop in template.
// this.metric_2_data_join = [{
//   ...this.metric_2_data[0],
//   metric_2_date_1: this.metric_2_date_1,
//   metric_2_date_2: this.metric_2_date_2,
//   metric_2: this.metric_2, // milliseconds // bigger date first so no negatives
//   metric_2_words: this.dhm( this.metric_2 ),
//   metric_2_who_service: this.metric_2_data[0].who_service,
//   metric_2_hours: this.returnHoursFunction(this.metric_2),
//   metric_2_text: 'Time to 2nd Attempt on Subject',
//   metric_2_title: 'Metric 2'
// }];

// sets up the totals and metrics widgets (Do the rest of calulations ouside of loops.)
// if(!isNaN(this.metric_2)){this.metric_2 = 0}
this.metric_2_count.push({
  metric_2_total: this.metric_2, // ms
});
this.arrayOfLinks.push(this.metric_2_data[0].subject_service_id);

} // end if
// ... Metric 3 (Calculation between)
// tslint:disable-next-line:max-line-length
this.metric_3_data = this.subject_service_metrix_search_full_results.filter((sbi)=>(sbi.service_number === '2'  && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id));
if (JSON.stringify(this.metric_3_data) != '[]') { // only load if data
this.metric_3_date_1 = new Date(this.metric_1);
this.metric_3_date_2 = new Date(this.metric_2);
this.metric_3 = this.metric_3_date_2.getTime() - this.metric_3_date_1.getTime(); // milliseconds // bigger date first so no negatives

// try setting an array and do a ngfor loop in template.
// this.metric_3_data_join = [{
//   ...this.metric_3_data[0],
//   metric_3_date_1: this.metric_3_date_1,
//   metric_3_date_2: this.metric_3_date_2,
//   metric_3: this.metric_3, // milliseconds // bigger date first so no negatives
//   metric_3_words: this.dhm( this.metric_3 ),
//   metric_3_who_service: this.metric_3_data[0].who_service,
//   metric_3_hours: this.returnHoursFunction(this.metric_3),
//   metric_3_text: 'Time between 1st & 2nd Attempt on Subject',
//   metric_3_title: 'Metric 3'
// }];

// if(!isNaN(this.metric_3)){this.metric_3 = 0}
// sets up the totals and metrics widgets (Do the rest of calulations ouside of loops.)
this.metric_3_count.push({
  metric_3_total: this.metric_3, // ms
});
// this.arrayOfLinks.push([
//   this.metric_2_data[0].subject_id
// ]);

} // end if

// ... Metric 4
// tslint:disable-next-line:max-line-length
this.metric_4_data = this.subject_service_metrix_search_full_results.filter((sbi)=>(sbi.service_number === '3'  && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id)); // attempt 3
if (JSON.stringify(this.metric_4_data) != '[]') { // only load if data
this.metric_4_date_1 = new Date(this.metric_4_data[0].created_date * 1000);

    let count_date_string = this.metric_4_data[0].created_date.length;
    console.log('Created Date Length: ' + count_date_string)
    if(count_date_string == 13){
      let str = this.metric_4_data[0].created_date.toString();
      // str.substring(0, str.length-3);
      console.log('Updated Date: ' + str.substring(0, str.length-3))
    let modified_date = str.substring(0, str.length-3); // removes the last three chars if longer than 10 or = 13
    this.metric_4_date_1 = new Date(modified_date * 1000);
    }

    // if undefined then is the javascript date I think...
    if(count_date_string == undefined){
      this.metric_4_date_1 = new Date(this.metric_4_data[0].created_date)
    }


this.metric_4_date_2 = new Date(this.metric_4_data[0].date_service);
this.metric_4 = this.metric_4_date_2.getTime() - this.metric_4_date_1.getTime(); // milliseconds // bigger date first so no negatives

// try setting an array and do a ngfor loop in template.
// this.metric_4_data_join = [{
//   ...this.metric_4_data[0],
//   metric_4_date_1: this.metric_4_date_1,
//   metric_4_date_2: this.metric_4_date_2,
//   metric_4: this.metric_4, // milliseconds // bigger date first so no negatives
//   metric_4_words: this.dhm( this.metric_4 ),
//   metric_4_who_service: this.metric_4_data[0].who_service,
//   metric_4_hours: this.returnHoursFunction(this.metric_4),
//   metric_4_text: 'Time to 3rd Attempt on Subject.',
//   metric_4_title: 'Metric 4'
// }];

// if(!isNaN(this.metric_4)){this.metric_4 = 0}
// sets up the totals and metrics widgets (Do the rest of calulations ouside of loops.)
this.metric_4_count.push({
  metric_4_total: this.metric_4, // ms
});

} // end if

// tslint:disable-next-line:max-line-length
this.metric_5_data = this.subject_service_metrix_search_full_results.filter((sbi)=>(sbi.service_number === '3' && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id));
if (JSON.stringify(this.metric_5_data) != '[]') { // only load if data
this.metric_5_date_1 = new Date(this.metric_3);
this.metric_5_date_2 = new Date(this.metric_4);
this.metric_5 = this.metric_5_date_2.getTime() - this.metric_5_date_1.getTime(); // milliseconds // bigger date first so no negatives

// try setting an array and do a ngfor loop in template.
// this.metric_5_data_join = [{
//   ...this.metric_5_data[0],
//   metric_5_date_1: this.metric_5_date_1,
//   metric_5_date_2: this.metric_5_date_2,
//   metric_5: this.metric_5, // milliseconds // bigger date first so no negatives
//   metric_5_words: this.dhm( this.metric_5 ),
//   metric_5_who_service: this.metric_5_data[0].who_service,
//   metric_5_hours: this.returnHoursFunction(this.metric_5),
//   metric_5_text: 'Time between 2nd & 3rd Attempt on Subject',
//   metric_5_title: 'Metric 5'
// }];

// if(!isNaN(this.metric_5 )){this.metric_5 = 0}
// sets up the totals and metrics widgets (Do the rest of calulations ouside of loops.)
this.metric_5_count.push({
  metric_5_total: this.metric_5, // ms
});
} // end if

// tslint:disable-next-line:max-line-length
//   // removed so that any subject can be closed and be calculated.
this.metric_6_data = this.subject_service_metrix_search_full_results.filter((sbi)=>( sbi.service_number === '1' && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id && sbi.job_status === 'CLOSED')); // attempt 1
if (JSON.stringify(this.metric_6_data) != '[]') { // only load if data
this.metric_6_date_1 = new Date(this.metric_6_data[0].created_date * 1000);


    let count_date_string = this.metric_6_data[0].created_date.length;
    console.log('Created Date Length: ' + count_date_string)
    if(count_date_string == 13){
      let str = this.metric_6_data[0].created_date.toString();
      // str.substring(0, str.length-3);
      console.log('Updated Date: ' + str.substring(0, str.length-3))
    let modified_date = str.substring(0, str.length-3); // removes the last three chars if longer than 10 or = 13
    this.metric_6_date_1 = new Date(modified_date * 1000);
    }

    // if undefined then is the javascript date I think...
    if(count_date_string == undefined){
      this.metric_6_date_1 = new Date(this.metric_6_data[0].created_date)
      // metric six has issue maybe changing thi above to date
      // this.metric_6_date_1 = new Date(this.metric_6_data[0].created_date * 1000);
      
    }






this.metric_6_date_2 = new Date(this.metric_6_data[0].updated_date * 1000);


          let count_date_string2 = this.metric_6_data[0].updated_date.length;
          console.log('Created Date Length: ' + count_date_string2)
          if(count_date_string2 == 13){
            let str2 = this.metric_6_data[0].updated_date.toString();
            // str.substring(0, str.length-3);
            console.log('Updated Date: ' + str2.substring(0, str2.length-3))
          let modified_date = str2.substring(0, str2.length-3); // removes the last three chars if longer than 10 or = 13
          this.metric_6_date_2 = new Date(modified_date * 1000);
          }

          if(count_date_string2 == 0){
            this.metric_6_date_2 = this.gfunc.today // chaged Metric
          }

          // if undefined then is the javascript date I think...
          if(count_date_string2 == undefined){
            this.metric_6_date_2 = new Date(this.metric_6_data[0].updated_date)
          }


          // this.metric_6_date_2 = this.gfunc.today // chaged Metric

this.metric_6 = this.metric_6_date_2.getTime() - this.metric_6_date_1.getTime(); // milliseconds // bigger date first so no negatives
console.log('job_id', this.metric_6_data[0].job_id);
console.log('created_date ', this.metric_6_data[0].created_date);
console.log('updated_date ', this.metric_6_data[0].updated_date);
console.log('metric 1 date', this.metric_6_date_1);
console.log('metric 2 date', this.metric_6_date_2);
console.log('metric 6', this.metric_6);




// try setting an array and do a ngfor loop in template.
// this.metric_6_data_join = [{
//   ...this.metric_6_data[0],
//   metric_6_date_1: this.metric_6_date_1,
//   metric_6_date_2: this.metric_6_date_2,
//   metric_6: this.metric_6, // milliseconds // bigger date first so no negatives
//   metric_6_words: this.dhm( this.metric_6 ),
//   metric_6_who_service: this.metric_6_data[0].who_service,
//   metric_6_hours: this.returnHoursFunction(this.metric_6),
//   metric_6_text: 'Time Job Start to Closed (or last updated if not yet closed).',
//   metric_6_title: 'Metric 6'
// }];
// sets up the totals and metrics widgets (Do the rest of calulations ouside of loops.)
// if(!isNaN(this.metric_6)){this.metric_6 = 0}
this.metric_6_count.push({
  metric_6_total: this.metric_6, // ms
});



} // end if




      // console.log('Current Metric 2: ', this.metric_2);
      // if (this.metric_2 == null) {
      // // tslint:disable-next-line:max-line-length
      // console.log('There is no secend attempt for subject: ' + this.subject_service_metrix_search_full_results[0].subject_number + ' ' + this.subject_service_metrix_search_full_results[0].subject_name );
      // } else {
      //  this.metric_2_string = this.convertMsToHM(this.metric_2);
      // }


// if(JSON.stringify(this.metric_2_data) !== '[]') {
//   this.metric_2_result = this.convertMsToHM(this.metric_2);
//   } else {
//   this.metric_2_result = null;
//   }
//   if(JSON.stringify(this.metric_3_data) !== '[]') {
//     this.metric_3_result = this.convertMsToHM(this.metric_3);
//   } else {
//     this.metric_2_result = null;
//     }

// this is how I can cade in an push each row to the data grid
// tslint:disable-next-line:max-line-length
// this.agent_metrics_chart_full.data([ 'Subject ' + res.subject_number , this.convertMsToHM(Time) , '0', '0', '0', '0', '0']); // array or string


// res2.subject_number + ' ' + res2.subject_name + ' Agent: ' + res2.who_service_name + ' ::' + res2.subject_service_id
// res2.subject_number + ' ' + res2.subject_name + ' Agent: ' + res2.who_service_name



// 1/02/24 added here double up as when searching not loading second time 










// if (JSON.stringify(this.metric_1_data) !== '[]') { } // end if  // only load if there is a first service data




// UNCOMMENT FOR LIVE
// Only Load agents if an agent is selected otherwise crashes the system.....
if(search_model.agent_id >= 1 && count_of_items >= 1){



      this.agent_metrics_chart_full.load({
        columns: [
          // tslint:disable-next-line:max-line-length
          // ['x',  'Metric 1: 1st Attempt on ', 'Metric 2: 2nd Attempt ', 'Metric 3: Time between 1st - 2nd Attempt', 'Metric 4: 3rd Attempt ', 'Metric 5: Time between 2nd - 3rd Attempt', 'Metric 6: Filed to Closed - (or last updated)'],
            // tslint:disable-next-line:max-line-length
            // this.convertMsToHM(this.metric_6)
            [res2.subject_number + ' ' + res2.subject_name + ' Agent: ' + res2.who_service_name, this.convertMsToHM(this.metric_1), this.convertMsToHM(this.metric_2), this.convertMsToHM(this.metric_3),  this.convertMsToHM(this.metric_4) ,  this.convertMsToHM(this.metric_5),  this.convertMsToHM(this.metric_6)],
        ],
       unload: ['SYSTEM AVERAGE'],
        type: 'line',
      
      });

}




                    // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
            this.job_metrix_join_results.push({
               ...this.subject_service_metrix_search_full[i],
              //  metric_1: metric_1,
              //  metric_1_words: metric_1_words,
              //  metric_2: metric_2,
              //  metric_2_words: metric_2_words,
              //  metric_3: metric_3,
              //  metric_3_words: metric_3_words,
              //  metric_4: metric_4,
              //  metric_4_words: metric_4_words,
              //  metric_5: metric_5,
              //  metric_5_words: metric_5_words,
              //  metric_6: metric_6,
              //  metric_6_words: metric_6_words,
              //  job_start_date: job_start_date,
              });

  } // end results for metric calcs and arrays loop.

              //  this.job_metrix_join_results = this.job_metrix_join_results;


// Totals
// I need to map the metric_1_count object and reduce



if(this.subject_service_metrix_search != '[]'){ 

this.total_metic_1_count = this.metric_1_count.filter((item) => item.metric_1_total)
.map((item) => +item.metric_1_total)
.reduce((sum, current) => sum + current);
this.metric_1_adverage_time_taken = (this.total_metic_1_count / count_of_items ); // ms
this.metric_1_adverage_time_taken_words = this.dhm(this.metric_1_adverage_time_taken);
if (this.metric_1_count.length != 0) {}

console.log('Current Metric 2 Count: ', this.metric_2_count);
if (this.metric_2_count.length != 0) {}
this.total_metic_2_count = this.metric_2_count.filter((item) => item.metric_2_total)
.map((item) => +item.metric_2_total)
.reduce((sum, current) => sum + current);
// reset frirst incase of prevoise search
this.metric_2_adverage_time_taken = (this.total_metic_2_count / count_of_items ); // ms
this.metric_2_adverage_time_taken_words = this.dhm(this.metric_2_adverage_time_taken);


if (this.metric_3_count.length != 0) {}
this.total_metic_3_count = this.metric_3_count.filter((item) => item.metric_3_total)
.map((item) => +item.metric_3_total)
.reduce((sum, current) => sum + current);
this.metric_3_adverage_time_taken = (this.total_metic_3_count / count_of_items ); // ms
this.metric_3_adverage_time_taken_words = this.dhm(this.metric_3_adverage_time_taken);


if (this.metric_4_count.length != 0) {}
this.total_metic_4_count = this.metric_4_count.filter((item) => item.metric_4_total)
.map((item) => +item.metric_4_total)
.reduce((sum, current) => sum + current);
this.metric_4_adverage_time_taken = (this.total_metic_4_count / count_of_items ); // ms
this.metric_4_adverage_time_taken_words = this.dhm(this.metric_4_adverage_time_taken);


if (this.metric_5_count.length != 0) {}
this.total_metic_5_count = this.metric_5_count.filter((item) => item.metric_5_total)
.map((item) => +item.metric_5_total)
.reduce((sum, current) => sum + current);
this.metric_5_adverage_time_taken = (this.total_metic_5_count / count_of_items ); // ms
this.metric_5_adverage_time_taken_words = this.dhm(this.metric_5_adverage_time_taken);


if (this.metric_6_count.length != 0) {}
this.total_metic_6_count = this.metric_6_count.filter((item) => item.metric_6_total)
.map((item) => +item.metric_6_total)
.reduce((sum, current) => sum + current);
this.metric_6_adverage_time_taken = (this.total_metic_6_count / count_of_items ); // ms
this.metric_6_adverage_time_taken_words = this.dhm(this.metric_6_adverage_time_taken);




// end all calulations and settups
            this.agent_metrics_chart_full.load({
              columns: [
                // tslint:disable-next-line:max-line-length
                // ['x',  'Metric 1: 1st Attempt on ', 'Metric 2: 2nd Attempt ', 'Metric 3: Time between 1st - 2nd Attempt', 'Metric 4: 3rd Attempt ', 'Metric 5: Time between 2nd - 3rd Attempt', 'Metric 6: Filed to Closed - (or last updated)'],
                  // tslint:disable-next-line:max-line-length
                  // this.convertMsToHM(this.metric_6)
                  ['AVERAGE_METRICS', this.convertMsToHM(this.metric_1_adverage_time_taken), this.convertMsToHM(this.metric_2_adverage_time_taken), this.convertMsToHM(this.metric_3_adverage_time_taken),  this.convertMsToHM(this.metric_4_adverage_time_taken) ,  this.convertMsToHM(this.metric_5_adverage_time_taken),  this.convertMsToHM(this.metric_6_adverage_time_taken)],
              ],
              // unload: ['SYSTEM AVERAGE'],
              type: 'area-spline',
              // type: 'bar',
              colors: {
                AVERAGE_METRICS: '#00ff00',
            },
            });

 } // end if.



 this.creating_search_data = 0; // finish loading.
    this.agent_metrics_chart_full.flush(); // redraw the graph
     this.grid.refresh();
     this.toastr.info("loaded data's")

   
  
      },
      error => {
 this.creating_search_data = 0; // finish loading.
 this.toastr.error("Error fetching data's")

      console.error('Error Loading !' + error.error);
      console.log(error);
      // return Observable.throw(error);
      }
      );
       



  
     


}









// outputs days, hours, munutes of a given time string function
// console.log( this.dhm( num ) );
// dhm(t) {
//   let cd = 24 * 60 * 60 * 1000,
//       ch = 60 * 60 * 1000,
//       d = Math.floor(t / cd),
//       h = Math.floor( (t - d * cd) / ch),
//       m = Math.round( (t - d * cd - h * ch) / 60000),
//       pad = function(n) { return n < 10 ? '0' + n : n; };
// if( m === 60 ) {
//   h++;
//   m = 0;
// }
// if( h === 24 ) {
//   d++;
//   h = 0;
// }
// return [d, pad(h), pad(m)].join(':');
// }

// ::@https://stackoverflow.com/questions/8528382/javascript-show-milliseconds-as-dayshoursmins-without-seconds
dhm (ms) {
  const days = Math.floor(ms / (24*60*60*1000));
  const daysms = ms % (24*60*60*1000);
  const hours = Math.floor(daysms / (60*60*1000));
  const hoursms = ms % (60*60*1000);
  const minutes = Math.floor(hoursms / (60*1000));
  const minutesms = ms % (60*1000);
  const sec = Math.floor(minutesms / 1000);
//  let days_words;
//  let hours_words;
//  let minutes_words;
//  let sec_words;
//   if (days) {  days_words = days + " DAYS, "; };
//   if (hours) {  hours_words = hours + " HOURS, "; };
//   if (minutes) {  minutes_words = minutes + " MINS, "; };
//   if (sec) {  sec_words = sec + " SECS."; };
  return days + " DAYS : " + hours + " HRS : " + minutes + " MINS : " + sec +" SECS";
  // return days_words  + hours_words + minutes_words + sec_words;



}


returnHoursFunction (ms) {
  const days = Math.floor(ms / (24*60*60*1000));
  const daysms = ms % (24*60*60*1000);
  const hours = Math.floor(daysms / (60*60*1000));
  const hoursms = ms % (60*60*1000);
  const minutes = Math.floor(hoursms / (60*1000));
  const minutesms = ms % (60*1000);
  const sec = Math.floor(minutesms / 1000);
//  let days_words;
//  let hours_words;
//  let minutes_words;
//  let sec_words;
//   if (days) {  days_words = days + " DAYS, "; };
//   if (hours) {  hours_words = hours + " HOURS, "; };
//   if (minutes) {  minutes_words = minutes + " MINS, "; };
//   if (sec) {  sec_words = sec + " SECS."; };
  return minutes;
  // return days_words  + hours_words + minutes_words + sec_words;



}


  // roundTo(123.456, 2);  // 123.46
  roundTo(num: number, places: number) {
    // let factor = 10 ** places;
    // return Math.round(num * factor) / factor;
    return num.toFixed(places);
  };

// ::@https://bobbyhadz.com/blog/javascript-convert-milliseconds-to-hours-and-minutes
  padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }
  
  convertMsToHM(milliseconds) {
    let seconds = Math.floor(milliseconds / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);
  
    seconds = seconds % 60;
    // 👇️ if seconds are greater than 30, round minutes up (optional)
    minutes = seconds >= 30 ? minutes + 1 : minutes;
  
    minutes = minutes % 60;
  
    // 👇️ If you don't want to roll hours over, e.g. 24 to 00
    // 👇️ comment (or remove) the line below
    // commenting next line gets you `24:00:00` instead of `00:00:00`
    // or `36:15:31` instead of `12:15:31`, etc.
   // hours = hours % 24;
  console.log(`${this.padTo2Digits(hours)}:${this.padTo2Digits(minutes)}`);
  // changed to dot to come as a percentage to load in graphs?

  // added additional check so that nulls and NaN's are not returned
  if (minutes > 0) {
    return `${this.padTo2Digits(hours)}.${this.padTo2Digits(minutes)}`;
  }else {
    return null;
  }
  }
  
  
    getFormUserLevels() {
      this._demoService.getFormUserLevels().subscribe(
         data2 => { this.user_levels = data2;
          console.log(data2);
       },
         err => console.error(err),
         () => console.log('done loading User Levels')
       );
     }
  
  
     getBrandTypes() {
      this._demoService.getBrandBrandTypes().subscribe(
         data => { this.brand_types = data; },
         err => console.error(err),
         // () => console.log('done loading candidate for update')
       );
     }
    
  
    getReportUsersSearch(search_model) {
  
      this._demoService.getReportUsersSearch(search_model).subscribe(
        data => { this.user_search = data;
          // pass so that the dates are correct in Sync
          // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
          this.user_search_results = DataUtil.parse.parseJson(data);
  // Count items of users search to loop through
  let  count_of_user_items = Object.keys(this.user_search).length;
  // now loop and push to join model
  for(let i=0;i < count_of_user_items; i++) {
    let res = this.user_search_results[i];
  
  
      // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
      this.brand_user_join_results.push({
        email_address: res.email_address,
        first_name: res.first_name,
        surname: res.surname,
        company_name: res.company_name,
        created_date: res.created_date,
              });
  
  
  } // end users loop.
  
  this.brand_user_join_results =  this.brand_user_join_results;
  this.grid.refresh();
       //  this.agent_grid.refresh();
        },
        error => {
        console.error('Error Loading !' + error.error);
        console.log(error);
        // return Observable.throw(error);
        }
      ); }
  
  
  
  addDays(days : number): Date{
  let futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + days);
  return futureDate;
  }
  
  
  removeDays(days : number): Date{
  let futureDate = new Date();
  futureDate.setDate(futureDate.getDate() - days);
  return futureDate;
  }
  
  /// TABS
  selectTab(tab_id: number) {
  this.staticTabs.tabs[tab_id].active = true;
  // this.brand_user_join_results = null; // refresh the model when a tab is clicked.?
  };
  
  
  
  
  
  
  
  
    // https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
    clickHandler(args: ClickEventArgs): void {
      if (args.item.id === 'Click') {
  
      //  this.grid.showSpinner();
  
      //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
     //  console.log(args.data.items);
     
  
  
      let pdfdata;
      const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
      for (let i = 0; i < query.queries.length; i++) {
        if (query.queries[i].fn === 'onPage') {
          query.queries.splice(i, 1);       // remove page query to get all records
          break;
        }
      }
      const fdata = new DataManager({ json: this.brand_user_join_results }).executeQuery(query).then((e: any) => {
        pdfdata = e.result as object[];  // get all filtered records
        const exportProperties = {
          dataSource: pdfdata,
        };
        //console.log(pdfdata.results);
        
       // this.search_results = pdfdata.records; // need this if a grouping is set.
        this.search_results = pdfdata;
        this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
        this.toastr.success( "Press Start To Process Que"); 
       // this.grid.pdfExport(exportProperties);
      }).catch((e) => true);
      }
  
     //  this.grid.hideSpinner();
  
  }
  
  
  exportPDFClick(args: ClickEventArgs): void {
    if (args.item.id === 'Grid_pdfexport') { // 'Grid_pdfexport' -> Grid component id + _ + toolbar item name
        this.grid.pdfExport();
    }
  }




  getReportAgentMetricsServices(search_model){
    this.join_results = [];
   // search_model.brand_type_id = 3;
  // search_model.access_level = 5;
    this._demoService.getReportAgentMetricsServices(search_model).subscribe(
      data => { this.agent_services = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.agent_services_results = DataUtil.parse.parseJson(data); 
  // get the users as well and join the records together
  // this.getReportUsersSearch(search_model);
  
  // now how to join two arrays of objects.
  // maybe pass results in to a new model.
  
  // Count items of brand search to loop through
  let  count_of_brand_items = Object.keys(this.agent_services).length;
  // now loop and push to join model
  for(let i=0;i < count_of_brand_items; i++) {
    let res = this.agent_services[i];
  
      // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
      this.join_results.push({
        email_address: res.email,
        first_name: res.name,
        surname: res.surname,
        company_name: res.name,
        created: res.created,
              });
  
  } // end brands loop.
  
  this.join_results = this.join_results;
  
       this.grid.refresh();
    
        },
        error => {
        console.error('Error Loading !' + error.error);
        console.log(error);
        // return Observable.throw(error);
        }
        );
         

          }

          // getBrandJobsTableDataGrid(brand_id, job_status_code, assigned_agent) {
            getAgentJobSubjects(search_model) {
            this._demoService.getAgentJobSubjects(search_model).subscribe(
              data => { this.agent_jobs = data;
        
              let res = data;
        
                // removes all words with length of > 6
               // const result = this.subjects_urgent.filter(word => this.subjects_urgent.length > 6);
        
               if (this.gfunc.sessionUserLevel === '9' ) { //client - remove these columns
               // let result_filter = this.subjects_urgent.filter(subject => this.subjects_urgent.job_type_id);
               // res.filter( e => this.subjects_urgent.allocated_to);
               // send results back to array.
              // this.subjects_urgent = result_filter;
               }
        
        
                this.agent_jobs_count = this.agent_jobs.length;
                // pass so that the dates are correct in Sync
                // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
                this.agent_jobs = DataUtil.parse.parseJson(data); 
               // console.log("Done loadng USER");
               // console.log(this.users);
          
          
              },
              error => {
              //  console.error('Error Loading User!');
              // return Observable.throw(error);
              }
            ); }



            getBrandsComboBoxAgents(combo_model) {
              this.combo_model.brand_type_id = 3;
             this._demoService.getBrandsComboBox(combo_model).subscribe(
                data => { this.brands_agent = data; },
                err => console.error(err),
                // () => console.log('done loading Trace Types')
              );
            }




 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
};


deleteSubjectService(subject_service_id) {
  if (confirm('Are you sure you want to delete this Service Information? ')) {
    this._demoService.deleteSubjectService(subject_service_id).subscribe(
       data => {
       // this.getSubjectServices(this.subject_id);
        // this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
         return true;
       },
       error => {
         console.error('Error deleting Attendence!');
        return console.log(error);
       }
    );
}
}

getBrandsComboBoxClients(combo_model) {
  this.combo_model.brand_type_id = 2;
 this._demoService.getBrandsComboBox(combo_model).subscribe(
    data => { this.brands_client = data; },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


}

